import { ReactComponent as WelcomeIcon } from "../../assets/img/inbox/welcome.svg";
import { NewConversation } from "./NewConversation";

export const NoMessages = () => {
    return (
        <div className="mx-auto flex h-full w-full max-w-screen-lg flex-1 flex-col items-center justify-center rounded-2xl border border-[#d5d5d5] bg-white">
            <WelcomeIcon className="mb-10" />
            {/*<div className="mt-5 mb-2 text-[20px] font-bold text-[#424242]">
                Welcome to your inbox
            </div>*/}
            <div className="font-roboto my-2 text-[16px] font-normal leading-[normal] tracking-[0] text-[#424242]">
                Start a conversation with your contacts!
            </div>
            <div className="my-2 w-2/3">
                <NewConversation />
            </div>
        </div>
    );
};
